module.exports = __webpack_public_path__ + "img/RM.6ff93bf9.jpg";